import { Params } from '@angular/router';
import { IFormErrors } from '@interfaces/IFormsErrors';
import {
  IChangeSaleTaskStatus,
  IConvertEnrolleeToLead,
  ICreateDeal,
  ICreateTask,
  ICreateTaskFromSalesManagerToLead,
  IDiscountEdit,
  IDiscountFixed,
  IDiscountForLead,
  IDiscountForStudent,
  IDiscountPercent,
  IEditDeal,
  IEnrollee,
  IEnrollPresentationData,
  IGetAccessToEditLeadData,
  IIndicateLeadToCourseAndGroup,
  ILeadDChangeData,
  IPaymentNoteForm,
  IPresentationForm,
  IPresentationInfo,
  ISalesMakeCourseRecruitment,
  ITaskFull,
  ITaskReasignForm,
  IUpdateTaskDeadLineForm,
} from '@interfaces/ISales';
import { Action } from '@ngrx/store';

export enum ESalesChangesActions {
  GetAccessToEditLeadDataRequest = '[Sales-changes] Get Access To Edit Lead Data Request',
  GetAccessToEditLeadDataSuccess = '[Sales-changes] Get Access To Edit Lead Data Success',
  GetAccessToEditLeadDataFailure = '[Sales-changes] Get Access To Edit Lead Data From Failure',
  ClearGetAccessToEditLeadDataErrors = '[Sales-changes] Clear Get Access To Edit Lead Data Errors',

  ChangeTaskExecuterRequest = '[Sales-changes] Change Task Executer Request',
  ChangeTaskExecuterSuccess = '[Sales-changes] Change Task Executer Success',
  ChangeTaskExecuterFailure = '[Sales-changes] Change Task Executer Failure',
  ClearChangeTaskExecuter = '[Sales-changes] Clear Change Task Executer',

  ChangePresentationInfoRequest = '[Sales-changes] Change Presentation Info Request',
  ChangePresentationInfoSuccess = '[Sales-changes] Change Presentation Info Success',
  ChangePresentationInfoFailure = '[Sales-changes] Change Presentation Info Failure',
  ClearChangePresentationInfoErrors = '[Sales-changes] Clear Change Presentation Info Errors',

  SendPresentationApplicationRequest = '[Sales-changes] Send Presentation Application Request',
  SendPresentationApplicationSuccess = '[Sales-changes] Send Presentation Application Success',
  SendPresentationApplicationFailure = '[Sales-changes] Send Presentation Application Failure',
  ClearSendPresentationApplicationErrors = '[Sales-changes] Clear Send Presentation Application Errors',

  AddLeadByHandRequest = '[Sales-changes] Add Lead By Hand Request',
  AddLeadByHandSuccess = '[Sales-changes] Add Lead By Hand Success',
  AddLeadByHandFailure = '[Sales-changes] Add Lead By HandFailure',
  ClearAddLeadByHandErrors = '[Sales-changes] Clear  Add Lead By Hand Errors',

  ConvertEnrolleeToLeadRequest = '[Sales-changes] Convert Enrollee To Lead Request',
  ConvertEnrolleeToLeadSuccess = '[Sales-changes] Convert Enrollee To Lead Success',
  ConvertEnrolleeToLeadFailure = '[Sales-changes] Convert Enrollee To Lead Failure',
  ClearConvertEnrolleeToLeadErrors = '[Sales-changes] Clear Convert Enrollee To Lead Errors',

  AddEnrolleeByHandRequest = '[Sales-changes] Add Enrollee By Hand Request',
  AddEnrolleeByHandSuccess = '[Sales-changes] Add Enrollee By Hand Success',
  AddEnrolleeByHandFailure = '[Sales-changes] Add Enrollee By HandFailure',
  ClearAddEnrolleeByHandErrors = '[Sales-changes] Clear  Add Enrollee By Hand Errors',

  DeleteEnrolleeRequest = '[Sales-changes] Delete Enrollee Request',
  DeleteEnrolleeSuccess = '[Sales-changes] Delete Enrollee Success',
  DeleteEnrolleeFailure = '[Sales-changes] Delete Enrollee Failure',
  ClearDeleteEnrolleeErrors = '[Sales-changes] Clear  Delete Enrollee Errors',

  EditEnrolleeRequest = '[Sales-changes] Edit Enrollee Request',
  EditEnrolleeSuccess = '[Sales-changes] Edit Enrollee Success',
  EditEnrolleeFailure = '[Sales-changes] Edit Enrollee Failure',
  ClearEditEnrolleeErrors = '[Sales-changes] Clear  Edit Enrollee Errors',

  MakeCourseRecruitmentRequest = '[Sales-changes] Make Course Recruitment Request',
  MakeCourseRecruitmentSuccess = '[Sales-changes] Make Course Recruitment Success',
  MakeCourseRecruitmentFailure = '[Sales-changes] Make Course Recruitment Failure',
  ClearMakeCourseRecruitmentErrors = '[Sales-changes] Clear Make Course Recruitment Errors',

  ChangeLeadDataRequest = '[Sales-changes] Change Lead Data Request',
  ChangeLeadDataSuccess = '[Sales-changes] Change Lead Data Success',
  ChangeLeadDataFailure = '[Sales-changes] Change Lead Data Failure',
  ClearChangeLeadDataErrors = '[Sales-changes] Clear Change Lead Data Errors',

  CreateTaskForSalesRequest = '[Sales-changes] Create Task For Sales Request',
  CreateTaskForSalesSuccess = '[Sales-changes] Create Task For Sales Success',
  CreateTaskForSalesFailure = '[Sales-changes] Create Task For Sales Failure',
  ClearCreateTaskForSalesErrors = '[Sales-changes] Clear Create Task For Sales Errors',

  UpdateTaskForSalesRequest = '[Sales-changes] Update Task For Sales Request',
  UpdateTaskForSalesSuccess = '[Sales-changes] Update Task For Sales Success',
  UpdateTaskForSalesFailure = '[Sales-changes] Update Task For Sales Failure',
  ClearUpdateTaskForSalesErrors = '[Sales-changes] Clear Update Task For Sales Errors',

  UpdateTaskDeadLineRequest = '[Sales-changes] Update Task DeadLine Request',
  UpdateTaskDeadLineSuccess = '[Sales-changes] Update Task DeadLine Success',
  UpdateTaskDeadLineFailure = '[Sales-changes] Update Task DeadLine Failure',
  ClearUpdateTaskDeadLineErrors = '[Sales-changes] Clear Task DeadLine Errors',

  AddFileToTaskRequest = '[Sales-view] Add File To Task Request',
  AddFileToTaskSuccess = '[Sales-view] Add File To Task Success',
  AddFileToTaskFailure = '[Sales-view] Add File To Task Failure',
  ClearAddFileToTaskErrors = '[Sales-view] Clear Add File To Task Errors',

  AddContractCredentialsRequest = '[Sales-view] Add Contract Credentials Request',
  AddContractCredentialsSuccess = '[Sales-view] Add Contract Credentials Success',
  AddContractCredentialsFailure = '[Sales-view] Add Contract Credentials Failure',
  ClearAddContractCredentialsErrors = '[Sales-view] Clear Add Contract Credentials Errors',

  EditContractCredentialsRequest = '[Sales-view] Edit Contract Credentials Request',
  EditContractCredentialsSuccess = '[Sales-view] Edit Contract Credentials Success',
  EditContractCredentialsFailure = '[Sales-view] Edit Contract Credentials Failure',
  ClearEditContractCredentialsErrors = '[Sales-view] Clear Edit Contract Credentials Errors',

  DeleteFileFromTaskRequest = '[Sales-view] Delete File From Task Request',
  DeleteFileFromTaskSuccess = '[Sales-view] Delete File From Task Success',
  DeleteFileFromTaskFailure = '[Sales-view] Delete File From Task Failure',
  ClearDeleteFileFromTaskErrors = '[Sales-view] Clear Delete File From Task Errors',

  ChangeSalesTaskStatusRequest = '[Sales-view] Change Sales Task Status Request',
  ChangeSalesTaskStatusSuccess = '[Sales-view] Change Sales Task Status Success',
  ChangeSalesTaskStatusFailure = '[Sales-view] Change Sales Task Status Failure',
  ClearChangeSalesTaskStatusErrors = '[Sales-view] Clear Change Sales Task Status Errors',

  ChangeEnrollDataInPresentationRequest = '[Sales-view] Change Enroll Data In Presentation Request',
  ChangeEnrollDataInPresentationSuccess = '[Sales-view] Change Enroll Data In Presentation Success',
  ChangeEnrollDataInPresentationFailure = '[Sales-view] Change Enroll Data In Presentation Failure',
  ClearChangeEnrollDataInPresentationErrors = '[Sales-view] Clear Change Enroll Data In Presentation Errors',

  IndicateLeadToCourseAndGroupRequest = '[Sales-changes] Indicate Lead To Course And Group Request',
  IndicateLeadToCourseAndGroupSuccess = '[Sales-changes] Indicate Lead To Course And Group Success',
  IndicateLeadToCourseAndGroupFailure = '[Sales-changes] Indicate Lead To Course And Group Failure',

  GenerateContractToLeadRequest = '[Sales-changes] Generate Contract To Lead Request',
  GenerateContractToLeadSuccess = '[Sales-changes] Generate Contract To Lead Success',
  GenerateContractToLeadFailure = '[Sales-changes] Generate Contract To Lead Failure',

  AddLeadDocumentsRequest = '[Sales-view] Add Lead Documents Request',
  AddLeadDocumentsSuccess = '[Sales-view] Add Lead Documents Success',
  AddLeadDocumentsFailure = '[Sales-view] Add Lead Documents Failure',

  DeleteLeadDocumentsRequest = '[Sales-view] Delete Lead Documents Request',
  DeleteLeadDocumentsSuccess = '[Sales-view] Delete Lead Documents Success',
  DeleteLeadDocumentsFailure = '[Sales-view] Delete Lead Documents Failure',

  CreateDealToLeadRequest = '[Sales-view] Create Deal To Lead Request',
  CreateDealToLeadSuccess = '[Sales-view] Create Deal To Lead Success',
  CreateDealToLeadFailure = '[Sales-view] Create Deal To Lead Failure',

  CloseDealToLeadRequest = '[Sales-view] Close Deal To Lead Request',
  CloseDealToLeadSuccess = '[Sales-view] Close Deal To Lead Success',
  CloseDealToLeadFailure = '[Sales-view] Close Deal To Lead Failure',

  EditDealRequest = '[Sales-view] Edit Deal Request',
  EditDealSuccess = '[Sales-view] Edit Deal Success',
  EditDealFailure = '[Sales-view] Edit Deal Failure',

  AddPaymentNoteRequest = '[Sales-view] Add Payment Note Request',
  AddPaymentNoteSuccess = '[Sales-view] Add Payment Note Success',
  AddPaymentNoteFailure = '[Sales-view] Add Payment Note Failure',
  ClearAddPaymentNoteErrors = '[Sales-view] Clear Add Payment Note Errors',

  AddDiscountRequest = '[Sales-view] Add Discount Request',
  AddDiscountSuccess = '[Sales-view] Add Discount Success',
  AddDiscountFailure = '[Sales-view] Add Discount Failure',

  EditDiscountRequest = '[Sales-view] Edit Discount Request',
  EditDiscountSuccess = '[Sales-view] Edit Discount Success',
  EditDiscountFailure = '[Sales-view] Edit Discount Failure',

  DeleteDealRequest = '[Sales-view] Delete Deal Request',
  DeleteDealSuccess = '[Sales-view] Delete Deal Success',
  DeleteDealFailure = '[Sales-view] Delete Deal Failure',
  ClearDeleteDealErrors = '[Sales-view] Clear Delete Deal Errors',

  AddDiscountForLeadRequest = '[Sales-view] Add Discount For Lead Request',
  AddDiscountForLeadSuccess = '[Sales-view] Add Discount For Lead Success',
  AddDiscountForLeadFailure = '[Sales-view] Add Discount For Lead Failure',

  DeleteDiscountLeadRequest = '[Sales-view] Delete Discount For Lead Request',
  DeleteDiscountLeadSuccess = '[Sales-view] Delete Discount For Lead Success',
  DeleteDiscountLeadFailure = '[Sales-view] Delete Discount For Lead Failure',

  DeleteDiscountStudentRequest = '[Sales-view] Delete Discount For Student Request',
  DeleteDiscountStudentSuccess = '[Sales-view] Delete Discount For Student Success',
  DeleteDiscountStudentFailure = '[Sales-view] Delete Discount For Student Failure',

  AddDiscountForStudentRequest = '[Sales-view] Add Discount For Student Request',
  AddDiscountForStudentSuccess = '[Sales-view] Add Discount For Student Success',
  AddDiscountForStudentFailure = '[Sales-view] Add Discount For Student Failure',

  ClearSalesChangesErrors = '[Sales-changes] Clear All Sales Changes Errors',
}

export class GetAccessToEditLeadDataRequest implements Action {
  public readonly type = ESalesChangesActions.GetAccessToEditLeadDataRequest;

  constructor(public data: IGetAccessToEditLeadData) {}
}

export class GetAccessToEditLeadDataSuccess implements Action {
  public readonly type = ESalesChangesActions.GetAccessToEditLeadDataSuccess;
}

export class GetAccessToEditLeadDataFailure implements Action {
  public readonly type = ESalesChangesActions.GetAccessToEditLeadDataFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearGetAccessToEditLeadDataErrors implements Action {
  public readonly type =
    ESalesChangesActions.ClearGetAccessToEditLeadDataErrors;
}

export class SendPresentationApplicationRequest implements Action {
  public readonly type =
    ESalesChangesActions.SendPresentationApplicationRequest;

  constructor(public data: IPresentationForm) {}
}

export class SendPresentationApplicationSuccess implements Action {
  public readonly type =
    ESalesChangesActions.SendPresentationApplicationSuccess;
}

export class SendPresentationApplicationFailure implements Action {
  public readonly type =
    ESalesChangesActions.SendPresentationApplicationFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearSendPresentationApplicationErrors implements Action {
  public readonly type =
    ESalesChangesActions.ClearSendPresentationApplicationErrors;
}

export class AddLeadByHandRequest implements Action {
  public readonly type = ESalesChangesActions.AddLeadByHandRequest;

  constructor(public data: IPresentationForm) {}
}

export class AddLeadByHandSuccess implements Action {
  public readonly type = ESalesChangesActions.AddLeadByHandSuccess;
}

export class AddLeadByHandFailure implements Action {
  public readonly type = ESalesChangesActions.AddLeadByHandFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearAddLeadByHandErrors implements Action {
  public readonly type = ESalesChangesActions.ClearAddLeadByHandErrors;
}

export class AddEnrolleeByHandRequest implements Action {
  public readonly type = ESalesChangesActions.AddEnrolleeByHandRequest;

  constructor(public data: IPresentationForm) {}
}

export class AddEnrolleeByHandSuccess implements Action {
  public readonly type = ESalesChangesActions.AddEnrolleeByHandSuccess;
}

export class AddEnrolleeByHandFailure implements Action {
  public readonly type = ESalesChangesActions.AddEnrolleeByHandFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearAddEnrolleeByHandErrors implements Action {
  public readonly type = ESalesChangesActions.ClearAddEnrolleeByHandErrors;
}

export class DeleteEnrolleeRequest implements Action {
  public readonly type = ESalesChangesActions.DeleteEnrolleeRequest;

  constructor(public id: number) {}
}

export class DeleteEnrolleeSuccess implements Action {
  public readonly type = ESalesChangesActions.DeleteEnrolleeSuccess;
}

export class DeleteEnrolleeFailure implements Action {
  public readonly type = ESalesChangesActions.DeleteEnrolleeFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearDeleteEnrolleeErrors implements Action {
  public readonly type = ESalesChangesActions.ClearDeleteEnrolleeErrors;
}

export class EditEnrolleeRequest implements Action {
  public readonly type = ESalesChangesActions.EditEnrolleeRequest;

  constructor(public id: number, public data: IEnrollee) {}
}

export class EditEnrolleeSuccess implements Action {
  public readonly type = ESalesChangesActions.EditEnrolleeSuccess;
}

export class EditEnrolleeFailure implements Action {
  public readonly type = ESalesChangesActions.EditEnrolleeFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearEditEnrolleeErrors implements Action {
  public readonly type = ESalesChangesActions.ClearEditEnrolleeErrors;
}

export class DeleteDealRequest implements Action {
  public readonly type = ESalesChangesActions.DeleteDealRequest;

  constructor(public id: number) {}
}

export class DeleteDealSuccess implements Action {
  public readonly type = ESalesChangesActions.DeleteDealSuccess;
}

export class DeleteDealFailure implements Action {
  public readonly type = ESalesChangesActions.DeleteDealFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearDeleteDealErrors implements Action {
  public readonly type = ESalesChangesActions.ClearDeleteDealErrors;
}

export class ChangePresentationInfoRequest implements Action {
  public readonly type = ESalesChangesActions.ChangePresentationInfoRequest;

  constructor(public data: IPresentationInfo) {}
}

export class ChangePresentationInfoSuccess implements Action {
  public readonly type = ESalesChangesActions.ChangePresentationInfoSuccess;
}

export class ChangePresentationInfoFailure implements Action {
  public readonly type = ESalesChangesActions.ChangePresentationInfoFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearChangePresentationInfoErrors implements Action {
  public readonly type = ESalesChangesActions.ClearChangePresentationInfoErrors;
}

export class ChangeEnrollDataInPresentationRequest implements Action {
  public readonly type =
    ESalesChangesActions.ChangeEnrollDataInPresentationRequest;

  constructor(
    public enroll_id: number,
    public data: IEnrollPresentationData,
    public token: string
  ) {}
}

export class ChangeEnrollDataInPresentationSuccess implements Action {
  public readonly type =
    ESalesChangesActions.ChangeEnrollDataInPresentationSuccess;
}

export class ChangeEnrollDataInPresentationFailure implements Action {
  public readonly type =
    ESalesChangesActions.ChangeEnrollDataInPresentationFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearChangeEnrollDataInPresentationErrors implements Action {
  public readonly type =
    ESalesChangesActions.ClearChangeEnrollDataInPresentationErrors;
}

export class MakeCourseRecruitmentRequest implements Action {
  public readonly type = ESalesChangesActions.MakeCourseRecruitmentRequest;

  constructor(public data: ISalesMakeCourseRecruitment, public id: number) {}
}

export class MakeCourseRecruitmentSuccess implements Action {
  public readonly type = ESalesChangesActions.MakeCourseRecruitmentSuccess;
}

export class MakeCourseRecruitmentFailure implements Action {
  public readonly type = ESalesChangesActions.MakeCourseRecruitmentFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearMakeCourseRecruitmentErrors implements Action {
  public readonly type = ESalesChangesActions.ClearMakeCourseRecruitmentErrors;
}

export class ChangeLeadDataRequest implements Action {
  public readonly type = ESalesChangesActions.ChangeLeadDataRequest;

  constructor(
    public data: ILeadDChangeData,
    public id: number,
    public options?: Params
  ) {}
}

export class ChangeLeadDataSuccess implements Action {
  public readonly type = ESalesChangesActions.ChangeLeadDataSuccess;
}

export class ChangeLeadDataFailure implements Action {
  public readonly type = ESalesChangesActions.ChangeLeadDataFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearChangeLeadDataErrors implements Action {
  public readonly type = ESalesChangesActions.ClearChangeLeadDataErrors;
}

export class CreateTaskForSalesRequest implements Action {
  public readonly type = ESalesChangesActions.CreateTaskForSalesRequest;

  constructor(
    public lead_id?: number,
    public taskData?: ICreateTaskFromSalesManagerToLead
  ) {}
}

export class CreateTaskForSalesSuccess implements Action {
  public readonly type = ESalesChangesActions.CreateTaskForSalesSuccess;

  constructor(public task: ICreateTask) {}
}

export class CreateTaskForSalesFailure implements Action {
  public readonly type = ESalesChangesActions.CreateTaskForSalesFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearCreateTaskForSalesErrors implements Action {
  public readonly type = ESalesChangesActions.ClearCreateTaskForSalesErrors;
}

export class UpdateTaskForSalesRequest implements Action {
  public readonly type = ESalesChangesActions.UpdateTaskForSalesRequest;

  constructor(public task_id: number, public data: ITaskFull) {}
}

export class UpdateTaskForSalesSuccess implements Action {
  public readonly type = ESalesChangesActions.UpdateTaskForSalesSuccess;
}

export class UpdateTaskForSalesFailure implements Action {
  public readonly type = ESalesChangesActions.UpdateTaskForSalesFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearUpdateTaskForSalesErrors implements Action {
  public readonly type = ESalesChangesActions.ClearUpdateTaskForSalesErrors;
}

export class AddFileToTaskRequest implements Action {
  public readonly type = ESalesChangesActions.AddFileToTaskRequest;

  constructor(public data: FormData) {}
}

export class AddFileToTaskSuccess implements Action {
  public readonly type = ESalesChangesActions.AddFileToTaskSuccess;
}

export class AddFileToTaskFailure implements Action {
  public readonly type = ESalesChangesActions.AddFileToTaskFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearAddFileToTaskErrors implements Action {
  public readonly type = ESalesChangesActions.ClearAddFileToTaskErrors;
}

export class DeleteFileFromTaskRequest implements Action {
  public readonly type = ESalesChangesActions.DeleteFileFromTaskRequest;

  constructor(public id: number) {}
}

export class DeleteFileFromTaskSuccess implements Action {
  public readonly type = ESalesChangesActions.DeleteFileFromTaskSuccess;
}

export class DeleteFileFromTaskFailure implements Action {
  public readonly type = ESalesChangesActions.DeleteFileFromTaskFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearDeleteFileFromTaskErrors implements Action {
  public readonly type = ESalesChangesActions.ClearDeleteFileFromTaskErrors;
}

export class AddContractCredentialsRequest implements Action {
  public readonly type = ESalesChangesActions.AddContractCredentialsRequest;

  constructor(public data: FormData) {}
}

export class AddContractCredentialsSuccess implements Action {
  public readonly type = ESalesChangesActions.AddContractCredentialsSuccess;
}

export class AddContractCredentialsFailure implements Action {
  public readonly type = ESalesChangesActions.AddContractCredentialsFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearAddContractCredentialsErrors implements Action {
  public readonly type = ESalesChangesActions.ClearAddContractCredentialsErrors;
}

export class EditContractCredentialsRequest implements Action {
  public readonly type = ESalesChangesActions.EditContractCredentialsRequest;

  constructor(public data: FormData, public id: number) {}
}

export class EditContractCredentialsSuccess implements Action {
  public readonly type = ESalesChangesActions.EditContractCredentialsSuccess;
}

export class EditContractCredentialsFailure implements Action {
  public readonly type = ESalesChangesActions.EditContractCredentialsFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearEditContractCredentialsErrors implements Action {
  public readonly type =
    ESalesChangesActions.ClearEditContractCredentialsErrors;
}

export class ChangeTaskExecuterRequest implements Action {
  public readonly type = ESalesChangesActions.ChangeTaskExecuterRequest;

  constructor(public data: ITaskReasignForm) {}
}

export class ChangeTaskExecuterSuccess implements Action {
  public readonly type = ESalesChangesActions.ChangeTaskExecuterSuccess;
}

export class ChangeTaskExecuterFailure implements Action {
  public readonly type = ESalesChangesActions.ChangeTaskExecuterFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearChangeTaskExecuter implements Action {
  public readonly type = ESalesChangesActions.ClearChangeTaskExecuter;
}

export class UpdateTaskDeadLineRequest implements Action {
  public readonly type = ESalesChangesActions.UpdateTaskDeadLineRequest;

  constructor(public data: IUpdateTaskDeadLineForm, public task_id: number) {}
}

export class UpdateTaskDeadLineSuccess implements Action {
  public readonly type = ESalesChangesActions.UpdateTaskDeadLineSuccess;
}

export class UpdateTaskDeadLineFailure implements Action {
  public readonly type = ESalesChangesActions.UpdateTaskDeadLineFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearUpdateTaskDeadLineErrors implements Action {
  public readonly type = ESalesChangesActions.ClearUpdateTaskDeadLineErrors;
}

export class ChangeSalesTaskStatusRequest implements Action {
  public readonly type = ESalesChangesActions.ChangeSalesTaskStatusRequest;

  constructor(public data: IChangeSaleTaskStatus, public task_id: number) {}
}

export class ChangeSalesTaskStatusSuccess implements Action {
  public readonly type = ESalesChangesActions.ChangeSalesTaskStatusSuccess;
}

export class ChangeSalesTaskStatusFailure implements Action {
  public readonly type = ESalesChangesActions.ChangeSalesTaskStatusFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearChangeSalesTaskStatusErrors implements Action {
  public readonly type = ESalesChangesActions.ClearChangeSalesTaskStatusErrors;
}

export class IndicateLeadToCourseAndGroupRequest implements Action {
  public readonly type =
    ESalesChangesActions.IndicateLeadToCourseAndGroupRequest;

  constructor(
    public data: IIndicateLeadToCourseAndGroup,
    public lead_id: number
  ) {}
}

export class IndicateLeadToCourseAndGroupSuccess implements Action {
  public readonly type =
    ESalesChangesActions.IndicateLeadToCourseAndGroupSuccess;
}

export class IndicateLeadToCourseAndGroupFailure implements Action {
  public readonly type =
    ESalesChangesActions.IndicateLeadToCourseAndGroupFailure;

  constructor(public errors: IFormErrors) {}
}

export class GenerateContractToLeadRequest implements Action {
  public readonly type = ESalesChangesActions.GenerateContractToLeadRequest;

  constructor(public lead_id: number, public data: { contract: number }) {}
}

export class GenerateContractToLeadSuccess implements Action {
  public readonly type = ESalesChangesActions.GenerateContractToLeadSuccess;
}

export class GenerateContractToLeadFailure implements Action {
  public readonly type = ESalesChangesActions.GenerateContractToLeadFailure;

  constructor(public errors: IFormErrors) {}
}

export class AddLeadDocumentsRequest implements Action {
  public readonly type = ESalesChangesActions.AddLeadDocumentsRequest;

  constructor(public data: FormData) {}
}

export class AddLeadDocumentsSuccess implements Action {
  public readonly type = ESalesChangesActions.AddLeadDocumentsSuccess;
}

export class AddLeadDocumentsFailure implements Action {
  public readonly type = ESalesChangesActions.AddLeadDocumentsFailure;

  constructor(public errors: IFormErrors) {}
}

export class DeleteLeadDocumentsRequest implements Action {
  public readonly type = ESalesChangesActions.DeleteLeadDocumentsRequest;

  constructor(public document_id: number) {}
}

export class DeleteLeadDocumentsSuccess implements Action {
  public readonly type = ESalesChangesActions.DeleteLeadDocumentsSuccess;
}

export class DeleteLeadDocumentsFailure implements Action {
  public readonly type = ESalesChangesActions.DeleteLeadDocumentsFailure;

  constructor(public errors: IFormErrors) {}
}

export class CreateDealToLeadRequest implements Action {
  public readonly type = ESalesChangesActions.CreateDealToLeadRequest;

  constructor(public data: ICreateDeal) {}
}

export class CreateDealToLeadSuccess implements Action {
  public readonly type = ESalesChangesActions.CreateDealToLeadSuccess;
}

export class CreateDealToLeadFailure implements Action {
  public readonly type = ESalesChangesActions.CreateDealToLeadFailure;

  constructor(public errors: IFormErrors) {}
}

export class CloseDealToLeadRequest implements Action {
  public readonly type = ESalesChangesActions.CloseDealToLeadRequest;

  constructor(public deals: { deals: number[] }) {}
}

export class CloseDealToLeadSuccess implements Action {
  public readonly type = ESalesChangesActions.CloseDealToLeadSuccess;

  constructor(public message: string[]) {}
}

export class CloseDealToLeadFailure implements Action {
  public readonly type = ESalesChangesActions.CloseDealToLeadFailure;

  constructor(public errors: IFormErrors) {}
}

export class EditDealRequest implements Action {
  public readonly type = ESalesChangesActions.EditDealRequest;

  constructor(public deal: IEditDeal, public deal_id: number) {}
}

export class EditDealSuccess implements Action {
  public readonly type = ESalesChangesActions.EditDealSuccess;
}

export class EditDealFailure implements Action {
  public readonly type = ESalesChangesActions.EditDealFailure;

  constructor(public errors: IFormErrors) {}
}

export class AddPaymentNoteRequest implements Action {
  public readonly type = ESalesChangesActions.AddPaymentNoteRequest;

  constructor(public data: IPaymentNoteForm) {}
}

export class AddPaymentNoteSuccess implements Action {
  public readonly type = ESalesChangesActions.AddPaymentNoteSuccess;
}

export class AddPaymentNoteFailure implements Action {
  public readonly type = ESalesChangesActions.AddPaymentNoteFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearAddPaymentNoteErrors implements Action {
  public readonly type = ESalesChangesActions.ClearAddPaymentNoteErrors;
}

export class AddDiscountRequest implements Action {
  public readonly type = ESalesChangesActions.AddDiscountRequest;

  constructor(public data: IDiscountFixed | IDiscountPercent) {}
}

export class AddDiscountSuccess implements Action {
  public readonly type = ESalesChangesActions.AddDiscountSuccess;
}

export class AddDiscountFailure implements Action {
  public readonly type = ESalesChangesActions.AddDiscountFailure;

  constructor(public errors: IFormErrors) {}
}

export class EditDiscountRequest implements Action {
  public readonly type = ESalesChangesActions.EditDiscountRequest;

  constructor(public data: IDiscountEdit, public id: number) {}
}

export class EditDiscountSuccess implements Action {
  public readonly type = ESalesChangesActions.EditDiscountSuccess;
}

export class EditDiscountFailure implements Action {
  public readonly type = ESalesChangesActions.EditDiscountFailure;

  constructor(public errors: IFormErrors) {}
}

export class AddDiscountForLeadRequest implements Action {
  public readonly type = ESalesChangesActions.AddDiscountForLeadRequest;

  constructor(public data: IDiscountForLead, public lead_id: number) {}
}

export class AddDiscountForLeadSuccess implements Action {
  public readonly type = ESalesChangesActions.AddDiscountForLeadSuccess;
}

export class AddDiscountForLeadFailure implements Action {
  public readonly type = ESalesChangesActions.AddDiscountForLeadFailure;

  constructor(public errors: IFormErrors) {}
}

export class DeleteDiscountLeadRequest implements Action {
  public readonly type = ESalesChangesActions.DeleteDiscountLeadRequest;

  constructor(public discount_id: number) {}
}

export class DeleteDiscountLeadSuccess implements Action {
  public readonly type = ESalesChangesActions.DeleteDiscountLeadSuccess;
}

export class DeleteDiscountLeadFailure implements Action {
  public readonly type = ESalesChangesActions.DeleteDiscountLeadFailure;

  constructor(public errors: IFormErrors) {}
}

export class DeleteDiscountStudentRequest implements Action {
  public readonly type = ESalesChangesActions.DeleteDiscountStudentRequest;

  constructor(public discount_id: number) {}
}

export class DeleteDiscountStudentSuccess implements Action {
  public readonly type = ESalesChangesActions.DeleteDiscountStudentSuccess;
}

export class DeleteDiscountStudentFailure implements Action {
  public readonly type = ESalesChangesActions.DeleteDiscountStudentFailure;

  constructor(public errors: IFormErrors) {}
}

export class AddDiscountForStudentRequest implements Action {
  public readonly type = ESalesChangesActions.AddDiscountForStudentRequest;

  constructor(public data: IDiscountForStudent) {}
}

export class AddDiscountForStudentSuccess implements Action {
  public readonly type = ESalesChangesActions.AddDiscountForStudentSuccess;
}

export class AddDiscountForStudentFailure implements Action {
  public readonly type = ESalesChangesActions.AddDiscountForStudentFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearSalesChangesErrors implements Action {
  public readonly type = ESalesChangesActions.ClearSalesChangesErrors;
}

export class ConvertEnrolleeToLeadRequest implements Action {
  public readonly type = ESalesChangesActions.ConvertEnrolleeToLeadRequest;

  constructor(public data: IConvertEnrolleeToLead, public id: number) {}
}

export class ConvertEnrolleeToLeadSuccess implements Action {
  public readonly type = ESalesChangesActions.ConvertEnrolleeToLeadSuccess;
}

export class ConvertEnrolleeToLeadFailure implements Action {
  public readonly type = ESalesChangesActions.ConvertEnrolleeToLeadFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearConvertEnrolleeToLeadErrors implements Action {
  public readonly type = ESalesChangesActions.ClearConvertEnrolleeToLeadErrors;
}

export type SalesChangesActions =
  | SendPresentationApplicationRequest
  | SendPresentationApplicationSuccess
  | SendPresentationApplicationFailure
  | ClearSendPresentationApplicationErrors
  | MakeCourseRecruitmentRequest
  | MakeCourseRecruitmentSuccess
  | MakeCourseRecruitmentFailure
  | ClearMakeCourseRecruitmentErrors
  | ChangePresentationInfoRequest
  | ChangePresentationInfoSuccess
  | ChangePresentationInfoFailure
  | ClearChangePresentationInfoErrors
  | GetAccessToEditLeadDataRequest
  | GetAccessToEditLeadDataSuccess
  | GetAccessToEditLeadDataFailure
  | ClearGetAccessToEditLeadDataErrors
  | ChangeLeadDataRequest
  | ChangeLeadDataSuccess
  | ChangeLeadDataFailure
  | ClearChangeLeadDataErrors
  | CreateTaskForSalesRequest
  | CreateTaskForSalesSuccess
  | CreateTaskForSalesFailure
  | ClearCreateTaskForSalesErrors
  | UpdateTaskForSalesRequest
  | UpdateTaskForSalesSuccess
  | UpdateTaskForSalesFailure
  | ClearUpdateTaskForSalesErrors
  | AddFileToTaskRequest
  | AddFileToTaskSuccess
  | AddFileToTaskFailure
  | ClearAddFileToTaskErrors
  | DeleteFileFromTaskRequest
  | DeleteFileFromTaskSuccess
  | DeleteFileFromTaskFailure
  | ClearDeleteFileFromTaskErrors
  | AddContractCredentialsRequest
  | AddContractCredentialsSuccess
  | AddContractCredentialsFailure
  | ClearAddContractCredentialsErrors
  | EditContractCredentialsRequest
  | EditContractCredentialsSuccess
  | EditContractCredentialsFailure
  | ClearEditContractCredentialsErrors
  | ChangeTaskExecuterRequest
  | ChangeTaskExecuterSuccess
  | ChangeTaskExecuterFailure
  | ClearChangeTaskExecuter
  | UpdateTaskDeadLineRequest
  | UpdateTaskDeadLineSuccess
  | UpdateTaskDeadLineFailure
  | ClearUpdateTaskDeadLineErrors
  | ChangeSalesTaskStatusRequest
  | ChangeSalesTaskStatusSuccess
  | ChangeSalesTaskStatusFailure
  | ClearChangeSalesTaskStatusErrors
  | ChangeEnrollDataInPresentationRequest
  | ChangeEnrollDataInPresentationSuccess
  | ChangeEnrollDataInPresentationFailure
  | ClearChangeEnrollDataInPresentationErrors
  | ClearSalesChangesErrors
  | IndicateLeadToCourseAndGroupRequest
  | IndicateLeadToCourseAndGroupSuccess
  | IndicateLeadToCourseAndGroupFailure
  | GenerateContractToLeadRequest
  | GenerateContractToLeadSuccess
  | GenerateContractToLeadFailure
  | AddLeadDocumentsRequest
  | AddLeadDocumentsSuccess
  | AddLeadDocumentsFailure
  | DeleteLeadDocumentsRequest
  | DeleteLeadDocumentsSuccess
  | DeleteLeadDocumentsFailure
  | CreateDealToLeadRequest
  | CreateDealToLeadFailure
  | CreateDealToLeadSuccess
  | CloseDealToLeadRequest
  | CloseDealToLeadFailure
  | CloseDealToLeadSuccess
  | EditDealRequest
  | EditDealFailure
  | EditDealSuccess
  | AddPaymentNoteRequest
  | AddPaymentNoteSuccess
  | AddPaymentNoteFailure
  | ClearAddPaymentNoteErrors
  | AddDiscountRequest
  | AddDiscountSuccess
  | AddDiscountFailure
  | EditDiscountRequest
  | EditDiscountSuccess
  | EditDiscountFailure
  | AddDiscountForLeadRequest
  | AddDiscountForLeadSuccess
  | AddDiscountForLeadFailure
  | DeleteDiscountLeadRequest
  | DeleteDiscountLeadSuccess
  | DeleteDiscountLeadFailure
  | DeleteDiscountStudentRequest
  | DeleteDiscountStudentSuccess
  | DeleteDiscountStudentFailure
  | AddDiscountForStudentRequest
  | AddDiscountForStudentSuccess
  | AddDiscountForStudentFailure
  | AddLeadByHandRequest
  | AddLeadByHandSuccess
  | AddLeadByHandFailure
  | ClearAddLeadByHandErrors
  | AddEnrolleeByHandRequest
  | AddEnrolleeByHandSuccess
  | AddEnrolleeByHandFailure
  | ClearAddEnrolleeByHandErrors
  | DeleteEnrolleeRequest
  | DeleteEnrolleeSuccess
  | DeleteEnrolleeFailure
  | ClearDeleteEnrolleeErrors
  | EditEnrolleeRequest
  | EditEnrolleeSuccess
  | EditEnrolleeFailure
  | ClearEditEnrolleeErrors
  | DeleteDealRequest
  | DeleteDealSuccess
  | DeleteDealFailure
  | ClearDeleteDealErrors
  | ConvertEnrolleeToLeadRequest
  | ConvertEnrolleeToLeadSuccess
  | ConvertEnrolleeToLeadFailure
  | ClearConvertEnrolleeToLeadErrors;
